module.exports = __webpack_public_path__ + "img/next.a59a9483.png";